import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sidebar-home',
  templateUrl: 'sidebar-home.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarHomeComponent {
  @Input() sectors: any = [];
  @Input() regions: any = [];
  @Input() filterName: any;
  @Input() filter: any;
  @Input() sidebar: string;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/sidebar-home/sidebar-home.ts